export default class RowDeleted {

    constructor(layout, row, index) {
        this.layout = layout
        this.row = row
        this.index = index
    }

    undo() {
        this.layout.rows.splice(this.index, 0, this.row)
    }

    redo() {
        this.layout.rows.splice(this.index, 1)
    }
}